module.exports = __webpack_public_path__ + "static/media/man enjoying single cask whisky.5becf3f7.jpg";